export const getRequiredErrorMessage = (label?: string) =>
  label ? `Заполните поле ${label}` : 'Заполните поле';

export const wrongEmailFormatErrorMessage = 'Неверный формат email';
export const wrongUrlFormatErrorMessage = 'Неверный формат url';
